package dev.lingvo.shared.screenshots.scene

import dev.lingvo.shared.screenshots.doc.Box
import dev.lingvo.shared.screenshots.doc.CanvasSize
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.doc.Page
import dev.lingvo.shared.screenshots.doc.Role
import dev.lingvo.shared.screenshots.doc.SceneSpec
import dev.lingvo.shared.screenshots.geom.Rect

/** Arrangements depend only on document geometry, so resizing can be repeated deterministically. */
data class SceneInput(
    val canvas: CanvasSize, val slots: Int, val safe: Rect, val spec: SceneSpec,
    val frame: FrameKind, val screenAspect: Double,
)

/** Role and role-slot preserve semantic layer identity when a scene is rearranged. */
data class Placement(val role: Role, val roleSlot: Int, val box: Box, val z: Int)

/** One arrangement contract serves templates and interactive scene changes. */
interface SceneArranger {
    /** Produces geometry without mutating document content. */
    fun arrange(input: SceneInput): List<Placement>
    /** Applies geometry while retaining user content and layer identities. */
    fun apply(page: Page, input: SceneInput): Page
    /** Joins pages without losing their slot references. */
    fun toPanorama(pages: List<Page>, canvas: CanvasSize): Page
    /** Restores individual store canvases from a panorama. */
    fun splitPanorama(page: Page, canvas: CanvasSize): List<Page>
}
